import reducerHelper from 'helpers/reducers';

export const updateFilterCategory = (type, category) => {
    if (!type || !category) {
        return;
    }

    // Fetch the filterCateogries.
    const filterCategories = reducerHelper.getFilterCategories();

    // Validate if category is available in the
    if (!~filterCategories.indexOf(category)) {
        return;
    }

    return {
        type: `${ type }_LIST_FILTER_CATEGORY`,
        payload: category,
    };
};

export const updateFilters = (type, payload) => {
    return {
        type: `${ type }_LIST_FILTER_UPDATE`,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/listActions.js